/* LumaLoop site chrome for the Shopify theme: mobile drawer and scroll
   reveals. Deliberately has no product or cart logic — ll-pdp.js owns that,
   and ll-site.js is for the static preview only. Loading ll-site.js here
   overwrote the add-to-cart button, because it expects a window.LL_PRODUCT
   that does not exist on Shopify. */
(function () {
  'use strict';

  var burger = document.getElementById('burger');
  var drawer = document.getElementById('drawer');
  if (burger && drawer) {
    /* The drawer used to start at var(--header-h), which assumes the header
       sits at the very top. With the announcement bar above it the header is
       lower, so the first link slid underneath it. Measure where the header
       actually ends at the moment it opens. */
    var head = document.querySelector('header.ll-head');
    function placeDrawer() {
      var top = head ? Math.max(0, Math.round(head.getBoundingClientRect().bottom)) : 0;
      drawer.style.top = top + 'px';
    }
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      if (!open) placeDrawer();
      burger.setAttribute('aria-expanded', String(!open));
      drawer.setAttribute('data-open', String(!open));
      document.body.classList.toggle('is-locked', !open);
    });
    window.addEventListener('resize', function () {
      if (drawer.getAttribute('data-open') === 'true') placeDrawer();
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        burger.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('data-open', 'false');
        document.body.classList.remove('is-locked');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') {
        burger.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('data-open', 'false');
        document.body.classList.remove('is-locked');
      }
    });
  }

  /* Reveal-on-scroll, written so it cannot leave content invisible.

     The previous version waited for isIntersecting at a 6% threshold. A fast
     flick on a phone can carry an element from below the fold to above it
     between two observation frames, so that entry never arrives, and the
     element sits at opacity 0 for the rest of the visit. Four of the ten on
     the home page were doing exactly that.

     So: anything that is intersecting OR has already been scrolled past is
     revealed, a passive scroll sweep catches whatever the observer missed,
     and a timer reveals everything regardless after a few seconds. The
     animation is a nicety; being readable is not. */
  (function reveals() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.rv'));
    if (!items.length) return;

    /* Belt and braces. Adding `in` is supposed to transition the element to
       opacity 1, but a transition that is created while the tab is throttled
       can sit at time 0 and never tick, which leaves a section carrying the
       class and still invisible — the same end state as the observer bug this
       file already guards against. So a second after we ask, we check, and if
       it did not take we write the finished state straight onto the element.
       Nothing here is load-bearing for the animation; it only guarantees the
       content ends up readable. */
    function settle(el) {
      window.setTimeout(function () {
        var o = parseFloat(window.getComputedStyle(el).opacity);
        if (o < 1) {
          el.style.transition = 'none';
          el.style.opacity = '1';
          el.style.transform = 'none';
        }
      }, 1200);
    }

    function show(el) {
      el.classList.add('in');
      settle(el);
      var i = items.indexOf(el);
      if (i > -1) items.splice(i, 1);
    }
    function showAll() { items.slice().forEach(show); }

    if (!('IntersectionObserver' in window)) { showAll(); return; }

    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var past = e.boundingClientRect.top < (e.rootBounds ? e.rootBounds.bottom : window.innerHeight);
        if (e.isIntersecting || past) { show(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    items.forEach(function (el) { io.observe(el); });

    /* the net: anything above the fold that the observer did not report */
    var ticking = false;
    function sweep() {
      ticking = false;
      items.slice().forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) {
          io.unobserve(el); show(el);
        }
      });
      if (!items.length) window.removeEventListener('scroll', onScroll);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(sweep);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    /* and the floor: never leave anything hidden for long */
    window.setTimeout(function () { io.disconnect(); showAll(); }, 4000);
  })();
})();

/* --------------------------------------------------------------------------
   Rotating hero.

   Crossfades stacked slides. Deliberately:
   - does nothing with one slide, so the markup is the same either way;
   - honours prefers-reduced-motion by never starting;
   - pauses when the tab is hidden, so it is not burning frames in a
     background tab;
   - waits for a slide to decode before showing it, so a slow connection
     fades to a blank frame rather than a half-painted one.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';
  var box = document.getElementById('heroSlides');
  if (!box) return;
  var slides = Array.prototype.slice.call(box.querySelectorAll('.hero__img'));
  if (slides.length < 2) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var every = parseInt(box.dataset.interval, 10);
  if (!every || every < 1500) every = 3000;

  var i = 0, timer = null, hydrated = false;

  /* Slides 2..n ship with data-src only, so the mobile first paint is one
     image rather than six. Promote them once the page has loaded and the
     connection does not look constrained. */
  function hydrate() {
    if (hydrated) return;
    hydrated = true;
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
    slides.forEach(function (img) {
      if (!img.dataset.src) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      delete img.dataset.src;
    });
  }

  function show(n) {
    slides[i].classList.remove('is-on');
    i = n;
    slides[i].classList.add('is-on');
  }

  function next() {
    var n = (i + 1) % slides.length;
    var img = slides[n];
    if (img.decode) {
      img.decode().then(function () { show(n); }).catch(function () { show(n); });
    } else {
      show(n);
    }
  }

  function start() {
    if (!hydrated) return;           /* nothing to rotate to yet */
    if (!timer) timer = window.setInterval(next, every);
  }
  function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

  document.addEventListener('visibilitychange', function () {
    document.hidden ? stop() : start();
  });

  function begin() {
    hydrate();
    if (!document.hidden) start();
  }
  /* Wait for load so the hero image and the fold are not competing with five
     more downloads. Call requestIdleCallback ON window — detaching it and
     invoking it bare throws "Illegal invocation", which silently killed the
     whole rotation the first time around. */
  function soon(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: 1200 });
    } else {
      window.setTimeout(fn, 400);
    }
  }
  if (document.readyState === 'complete') {
    soon(begin);
  } else {
    window.addEventListener('load', function () { soon(begin); });
  }
})();

/* ---------------------------------------------------------- hero video
   The poster does the first paint. The file is only fetched once the page
   has settled, and not at all when the visitor is on a metered or slow
   connection or has asked for reduced motion — in those cases the poster
   is the hero, which is why it has to be a finished frame and not a
   placeholder. Muted + playsinline, because iOS refuses to autoplay
   anything else, and a rejected play() just leaves the poster up. */
(function () {
  'use strict';

  var vids = Array.prototype.filter.call(
    document.querySelectorAll('.hero__video'),
    function (el) { return el.dataset.src; });
  if (!vids.length) return;

  function reduced() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) { return false; }
  }

  function thrifty() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    return /(^|-)(2g|slow-2g)$/.test(c.effectiveType || '');
  }

  if (reduced() || thrifty()) return;   /* the poster stays, and that is fine */

  function start() {
    vids.forEach(function (v) {
      /* a phone gets the 640px cut: same clip, about a third of the bytes */
      var small = v.dataset.srcSm;
      v.src = (small && window.innerWidth < 860) ? small : v.dataset.src;
      v.load();
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* autoplay refused — keep the poster */ });
      v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
    });
  }

  function soonest(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: 2000 });
    } else {
      window.setTimeout(fn, 600);
    }
  }

  /* don't hold a video decoding off-screen */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (!v.src) return;
        if (e.isIntersecting) {
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0 });
    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'complete') soonest(start);
  else window.addEventListener('load', function () { soonest(start); });
})();

/* ------------------------------------------------------- home sticky bar
   Shows once the hero's own button has scrolled away, so the ask is never
   on screen twice at once. */
(function () {
  'use strict';
  var bar = document.getElementById('homeSticky');
  if (!bar) return;
  /* The hero's own button moved inside the film, so .hero__actions no longer
     exists on the home page. Without an anchor this fell through to "always
     show", which put the ask on screen twice — the very thing the bar is
     written to avoid. Look for the pill first. */
  var anchor = document.querySelector('.hero__cta .btn, .hero__actions .btn');
  if (!anchor || !('IntersectionObserver' in window)) { bar.setAttribute('data-show', 'true'); return; }

  /* Two reasons to stand down, and the bar shows only when neither applies.

     The hero's own button is the first: the ask should never be on screen
     twice at once.

     The contact form is the second. Someone typing a message has already
     said yes to something; floating "Discover the bracelet" over the field
     they are filling in is the wrong ask at the wrong moment, and on a
     phone it covers the box. */
  var heroVisible = true;
  var contactVisible = false;

  function sync() {
    var show = !heroVisible && !contactVisible;
    bar.setAttribute('data-show', String(show));
    /* and the page only holds a gap open while the bar is in it */
    document.body.classList.toggle('has-homebar', show);
  }

  new IntersectionObserver(function (es) {
    heroVisible = es[0].isIntersecting;
    sync();
  }, { threshold: 0 }).observe(anchor);

  var contact = document.querySelector('.ct');
  if (contact) {
    /* Not the moment its top edge appears — the FAQ is still on screen then
       and the bar would stand down for most of the page. Shrinking the root
       by 40% at the foot means this counts as "in view" only once the form
       has climbed into the working part of the screen, which is where it
       sits when someone is filling it in. Measuring the region rather than
       how much of the element shows also survives a phone keyboard opening
       and halving the viewport. */
    new IntersectionObserver(function (es) {
      contactVisible = es[0].isIntersecting;
      sync();
    }, { rootMargin: '0px 0px -40% 0px', threshold: 0 }).observe(contact);
  }
})();

/* The reviews row drifts in CSS now — no script. It pauses on hover and
   under prefers-reduced-motion, where it becomes a plain scrollable row. */

/* --------------------------------------------------------------- the reviews row

   Driven by the rail's scrollLeft, one frame at a time, rather than by a CSS
   animation sliding the whole 2000px track around.

   The transform version kept going blank on a phone partway through its
   cycle and coming back when the loop wrapped. Everything about it invited
   that: a very wide element, promoted to its own layer, moved by a
   percentage of its own width, under a mask. Any one of those can leave the
   compositor with a layer it has not finished rasterising, and there is
   nothing on screen until something forces a redraw.

   scrollLeft has none of it. The browser paints only what fits in the rail,
   the number we set is always between zero and one set's width, and if the
   script never runs the CSS keyframes are still there doing the old job.

   It also means a finger can push the row along, which is what most people
   try first. */
(function () {
  'use strict';

  var rail = document.getElementById('revsRail');
  if (!rail) return;
  var track = rail.querySelector('.revs__track');
  if (!track) return;

  try {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  } catch (e) { /* carry on */ }

  var cards = Array.prototype.slice.call(track.children);
  if (cards.length < 2) return;

  /* One set is the first half: the markup prints every review twice so the
     row can wrap without a seam. */
  function outer(el) {
    var r = el.getBoundingClientRect();
    var m = parseFloat(window.getComputedStyle(el).marginRight) || 0;
    return r.width + m;
  }
  var setWidth = 0;
  function measure() {
    setWidth = 0;
    for (var i = 0; i < cards.length / 2; i++) setWidth += outer(cards[i]);
  }
  measure();
  if (setWidth < 10) return;              /* nothing laid out yet — leave the CSS to it */

  /* the section setting is seconds for one full pass of one set */
  var secs = parseFloat(window.getComputedStyle(track).getPropertyValue('--revs-speed')) || 70;
  var pps = setWidth / secs;

  rail.setAttribute('data-driven', 'true');
  track.style.animation = 'none';
  track.style.transform = 'none';

  var held = 0;                            /* >0 while a finger or a pointer has it */
  var onScreen = true;
  var last = 0;
  var raf = 0;

  /* We keep our own position as a float.

     scrollLeft snaps to the device pixel grid. At 60fps this row advances
     about four tenths of a pixel per frame, so reading scrollLeft back each
     frame and adding to it meant reading a rounded-up number every time —
     the row ran a quarter faster than the speed the section asks for, and
     by a different amount on every screen density. The float is the truth;
     scrollLeft is just where we paint it. */
  var pos = rail.scrollLeft;
  var wrote = pos;

  function step(ts) {
    raf = 0;
    if (!last) last = ts;
    var dt = Math.min(ts - last, 120) / 1000;
    last = ts;

    /* a finger moved it: take their position and carry on from there */
    if (Math.abs(rail.scrollLeft - wrote) > 2) pos = rail.scrollLeft;

    if (!held) {
      pos += pps * dt;
      if (pos >= setWidth) pos -= setWidth;  /* the next set is identical, so this is invisible */
      else if (pos < 0) pos += setWidth;
      rail.scrollLeft = pos;
      wrote = rail.scrollLeft;
    }
    schedule();
  }

  function schedule() {
    if (raf || document.hidden || !onScreen) return;
    raf = window.requestAnimationFrame(step);
  }
  function stop() {
    if (raf) { window.cancelAnimationFrame(raf); raf = 0; }
    last = 0;
  }

  document.addEventListener('visibilitychange', function () {
    document.hidden ? stop() : schedule();
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      onScreen = es[0].isIntersecting;
      onScreen ? schedule() : stop();
    }, { threshold: 0 }).observe(rail);
  }

  /* Hold while someone is reading or dragging. A pointer that can hover
     pauses on hover; a finger pauses while it is down and for a moment
     after, so letting go does not snatch the row away. */
  var release = 0;
  function hold() { held++; window.clearTimeout(release); }
  function letGo(delay) {
    window.clearTimeout(release);
    release = window.setTimeout(function () { held = 0; last = 0; schedule(); }, delay);
  }
  var canHover = false;
  try { canHover = window.matchMedia('(hover:hover)').matches; } catch (e) {}
  if (canHover) {
    rail.addEventListener('mouseenter', hold);
    rail.addEventListener('mouseleave', function () { letGo(0); });
  }
  rail.addEventListener('pointerdown', hold);
  rail.addEventListener('touchstart', hold, { passive: true });
  window.addEventListener('pointerup', function () { letGo(1800); });
  window.addEventListener('touchend', function () { letGo(1800); }, { passive: true });
  rail.addEventListener('focusin', hold);
  rail.addEventListener('focusout', function () { letGo(0); });

  window.addEventListener('resize', function () {
    measure();
    if (setWidth > 10) pps = setWidth / secs;
  }, { passive: true });

  schedule();
})();

/* --------------------------------------------------------- announcement bar
   Hidden in the markup and shown here, so a visitor who closed it never sees
   it flash in and out on the next page. The key is a version string from the
   section, so changing the message brings the bar back for everyone who
   dismissed the last one. */
(function () {
  'use strict';
  var bar = document.getElementById('annBar');
  if (!bar) return;

  var key = 'velor.ann.' + (bar.dataset.key || 'default');
  var closed = false;
  try { closed = window.localStorage.getItem(key) === '1'; } catch (e) { /* private window */ }
  if (closed) { bar.remove(); return; }

  bar.hidden = false;

  var x = document.getElementById('annClose');
  if (!x) return;
  x.addEventListener('click', function () {
    bar.hidden = true;
    try { window.localStorage.setItem(key, '1'); } catch (e) {}
  });
})();
